import type { FaireProductEntity } from "../../entity_types/product";

export const atc_baggu_2: FaireProductEntity = {
  token: "atc_baggu_2",
  type: "product",
  name: "Mini Shoulder Bag - Black",
  brandName: "Baggu",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b92f5d4b54512bb8edd93c171c9f4bfdccc2fb0a45d8803f8ca417ecf49c4976.jpeg",
  priceDollars: 24,
  msrpDollars: 48,
  description: "Reusable bag made from recycled materials by Baggu.",
  tags: ["bags", "accessories", "sustainable"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
